import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Schema } from 'src/utils/form';

const schema = Schema.object({
  descricao: Schema.string()
    .label(<FormattedMessage id="descricao" />)
    .required(),
  utilizarTipoPontoControle: Schema.array().label(),
  utilizarCodigoAutomatico: Schema.array().label(),
  agrupador: Schema.boolean().label(),
  idIntegracao: Schema.string()
    .label(<FormattedMessage id="idIntegracao" />)
    .required({
      onlyIf: (context) => {
        return !context.parent.value.utilizarCodigoAutomatico;
      },
    }),
  responsavel: Schema.string()
    .label(<FormattedMessage id="responsavel" />)
    .required({
      onlyIf: (context) => {
        return (
          context.parent.value &&
          context.parent.value.responsavelObrigatorio &&
          !context.parent.value.agrupador
        );
      },
    }),
  periodicidade: Schema.string()
    .label(<FormattedMessage id="periodicidade" />)
    .required({
      onlyIf: (context) => {
        return (
          context.parent.value &&
          context.parent.value.frequenciaControle &&
          context.parent.value.frequenciaControle.id == 1 &&
          !context.parent.value.agrupador
        );
      },
    }),
  tipoPontoControle: Schema.string().label(),
  anexoObrigatorio: Schema.string().label(
    <FormattedMessage id="anexoObrigatorio" />
  ),
  utilizarTipoEvidencia: Schema.string(),
  tipoEvidencias: Schema.string().label(
    <FormattedMessage id="tipoEvidencias" />
  ),
  calendario: Schema.string().label(
    <FormattedMessage id="label.calendarioPadrao" />
  ),
  configurarCalendarioPontoControle: Schema.string().label(),
  diasToleranciaRevisao: Schema.string().label(
    <FormattedMessage id="tolerancia" />
  ),
  tipoTolerancia: Schema.string().label(),
  avaliarConformidadeRevisaoControle: Schema.string().label(),
  validadores: Schema.string().label(<FormattedMessage id="validadores" />),
  numeroRevisoesGeradasAutomaticamente: Schema.string().label(
    <FormattedMessage id="numeroRevisoesGeradasAutomaticamente" />
  ),
  frequenciaControle: Schema.string()
    .label()
    .required({
      onlyIf: (context) => {
        return context.parent.value && !context.parent.value.agrupador;
      },
    }),
});

export default schema;
